import React from 'react';

import { Parallax } from 'react-scroll-parallax';

import { InsideParallaxImage } from "components/Image/Index";
import * as fromProjects from 'store/Projects';

import { a } from '@react-spring/web';
import { useIntersect } from 'hooks/useIntersect';
import { useAnimateInSpring } from 'hooks/useAnimateInSpring';
import { initialOffset } from 'components/Animations/SpringProperties/SpringProperties';

interface IProps {
  animationReady: boolean;
  index: number;
  angle: number;
  image: fromProjects.IContentMassiveScrollingImage;
}

export const Image: React.FC<IProps> = ({ animationReady, index, angle, image, ...props }) => {
  const [inViewRef, inView] = useIntersect({
    startObserving: animationReady,
  });

  const rotationAngleDegrees = angle;
  const rotationAngleRadians = rotationAngleDegrees * Math.PI / 180;

  const imageWidth = (100 / image.heightRatio);
  const isFirstImage: number = (index === 0 ? 1 : 0);
  //const isLastImage: number = (((index + 1) === this.state.images.length) ? 1 : 0);
  const isOddImage: number = (((index % 2) === 0) ? 1 : -1);
  const maxMovementOnScroll: number = 200 * isOddImage;

  const imagePlaceholderStyles = {
    height: `calc(   (  100vh / ${Math.cos(rotationAngleRadians)}  )    )`,
    //paddingBottom: `calc(   (  100% * ${Math.tan(rotationAngleRadians)} * ${isLastImage}  )    )`,
    //height: `calc(   (  100vh / ${Math.cos(15.86 * Math.PI / 180)}  ) + (  ${isLastImage}px  )   )`,
    //height: `calc(   (  100vh / ${Math.cos(15.86 * Math.PI / 180)}  ) + (  ${(((index + 1) === this.state.images.length) ? 1 : 0)} * (  100% * ${Math.tan(15.86 * Math.PI / 180)}  )  )   )`,
  };

  const animateInSpring = useAnimateInSpring(inView);

  const imageWrapperStyles = {
    opacity: animateInSpring.active,
    //transform: `translateY(calc(  (${interpolatingStyles[1].x} * -30px) + 30px)  )`,
    //transform: `rotate(calc(  15.86deg  )) translateY(calc(  (${interpolatingStyles[1].x} * -30px) + 30px)  ) translateX(calc(  ${image.imageOffset} * -1  ))`,
    //transform: `rotate(calc(  ${rotationAngleDegrees}deg  )) translateY(calc(  (${interpolatingStyles[1].x} * -30px) + 30px)  ) translateX(calc(  (  (  100vh * ${Math.tan(rotationAngleRadians)}  )  +  (  100% / ${Math.cos(rotationAngleRadians)}  )  ) * 1  ))`,
    transform: animateInSpring.active.to(x => `rotate(calc(  ${rotationAngleDegrees}deg  )) translateX(calc(  (  (  100vh * ${Math.tan(rotationAngleRadians)}  )  +  (  100% / ${Math.cos(rotationAngleRadians)}  )  ) * (-1 * ${image.imageOffset})  +  (${initialOffset(x)} * ${isOddImage}) + (  ${isFirstImage} * ${maxMovementOnScroll} * -1px  )  ))`),
  };

  const parallaxStyles = {
    width: `calc(  ${imageWidth}vh  )`,
    transform: `translateX(calc(  ${image.imageOffset} * 100%  ))`,
  };

  return (
    <div ref={inViewRef} className='imagePlaceholder' style={imagePlaceholderStyles}>
      <a.figure key={index} className='imageWrapper' style={imageWrapperStyles}>
        <Parallax x={[maxMovementOnScroll + 'px', '0px']} tagOuter="figure">
          <a.div className='parallaxInner' style={parallaxStyles}>
            <InsideParallaxImage
              heightRatio={image.heightRatio}
              src={'/assets/images/work/' + image.url}
              alt={image.alt}
              animateImageIn={true}
              animationType={'reveal'}
            />
          </a.div>
        </Parallax>
      </a.figure>
    </div>
  );
};
